export const msalConfig = {
  auth: {
    clientId: "646c35f2-1729-4512-b8bc-f4787f4fac4c",
    authority: "https://login.microsoftonline.com/76f481ad-4b97-4594-bb1f-51ce7b9cff97", // This is a URL (e.g. https://login.microsoftonline.com/{your tenant ID})
    redirectUri: "https://cma.scottiplaw.com",
  },
  cache: {
    cacheLocation: "sessionStorage", // This configures where your cache will be stored
    storeAuthStateInCookie: false, // Set this to "true" if you are having issues on IE11 or Edge
  }
};

// Add scopes here for ID token to be used at Microsoft identity platform endpoints.
export const loginRequest = {
  scopes: ["User.Read"]
};


// Add the endpoints here for Microsoft Graph API services you'd like to use.
export const graphConfig = {
  graphMeEndpoint: "Enter_the_Graph_Endpoint_Here/v1.0/me"
};
